<template>
  <div class="attributes-table">
    <!-- <h3 class="p-5" v-if="!featuresLayer">Należy wybrać warstwę aktywną.</h3> -->
    <b-tabs ref="tabs">
      <b-tab title="Tabela atrybutów" active>
        <features-table
          ref="featureTable"
          @edited-data="handleEditedData"
        ></features-table>
      </b-tab>

      <!-- <b-tab :id="historyTabId" title="Historia" v-if="hasPermission('Data_changes_history')">
        <history-table @calculateTableHeight="calculateTableHeight"></history-table>
      </b-tab> -->
    </b-tabs>
  </div>
</template>

<script>
import FeaturesTable from './FeaturesTable/FeaturesTable';
// import HistoryTable from './HistoryTable/HistoryTable';
import { mapGetters } from 'vuex';
// import { FEATURES_TABLE_ACTIVE_TAB_SET } from '../store/mutations.type';

export default {
  name: 'AttributesTable',
  components: {
    FeaturesTable
    // HistoryTable
  },
  data: function() {
    return {
      tabIndex: null,
      attributesTabId: 'attributes',
      historyTabId: 'history'
    };
  },
  computed: {
    ...mapGetters(['featuresLayer'])
  },
  props: {
    disableEditModeActions: false,
    // editModeLayer: null,
    reload: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  methods: {
    tabChanged(tabIndex) {
      // let tab = this.$refs.tabs.tabs[tabIndex];
      // this.$store.commit(FEATURES_TABLE_ACTIVE_TAB_SET, {
      //   attrTab: tab.id === this.attributesTabId,
      //   historyTab: tab.id === this.historyTabId,
      // });
    },
    calculateTableHeight(id) {
      let featuresBody = document.getElementById(id);
      if (!featuresBody) {
        return;
      }
      let attributesTableHeight = 0;
      let offsetTop = featuresBody.offsetTop + featuresBody.clientTop;
      let parent = featuresBody.parentElement;
      if (!parent) {
        return;
      }
      while (!parent.classList.contains('resizable-panel')) {
        parent = parent.parentElement;
      }
      attributesTableHeight = parent.clientHeight;
      parent = featuresBody.offsetParent;
      if (!parent) {
        return;
      }
      while (!parent.classList.contains('resizable-panel')) {
        offsetTop += parent.offsetTop + parent.clientTop;
        parent = parent.offsetParent;
      }
      featuresBody.style.height = attributesTableHeight - offsetTop + 'px';
    },
    scrollToColumn(column) {
      // if(this.$refs.featureTable) {
      //   this.$refs.featureTable.scrollToColumn(column);
      // }
    },
    handleEditedData() {
      this.$emit('edited-data');
    }
  }
};
</script>

<style>
.attributes-table {
  background-color: rgba(255, 255, 255, 0.85);
  /* display: -webkit-flex; */
  display: flex;
  /* -webkit-flex: 1; */
  flex: 1;
  /* -webkit-flex-direction: column; */
  flex-direction: column;
  /*-webkit-align-items: stretch;
  align-items: stretch;
}
.attributes-table h3 {
  /* -webkit-align-self: center;
  align-self: center; */
}
</style>
